import React, { useState } from 'react';

//images
import Lazy from 'components/Lazy';
import logoImage from 'css/images/logo-mazda.svg';
import { useAlert } from 'context/AlertContext';

const LoginPage = ({ onLogin, firstLoginCod, onCompleteFirstLogin }) => {
	const { showAlert } = useAlert();
	const [showForm, setShowForm] = useState(false);
	const [formData, setFormData] = useState({
		cod_empleado: '',
		pwd: '',
	});
	const [acceptPolicy, setAcceptPolicy] = useState(false);
	const [firstLoginForm, setFirstLoginForm] = useState({
		name: '',
		ape1: '',
		ape2: '',
		email: '',
		telefono: '',
		dni: '',
		dom_fiscal: '',
		pwd: '',
	});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		onLogin(formData);
	};

	const handleBackClick = () => {
		setShowForm(false);
		setFormData({ cod_empleado: '', pwd: '' });
	};

	const handleFirstLoginChange = (e) => {
		const { name, value } = e.target;
		setFirstLoginForm((prev) => ({ ...prev, [name]: value }));
	};

	const handleFirstLoginSubmit = (e) => {
		e.preventDefault();
		const { name, ape1, ape2, email, telefono, dni, dom_fiscal, pwd } = firstLoginForm;
		if (!name || !ape1 || !ape2 || !email || !telefono || !dni || !dom_fiscal || !pwd) {
			showAlert('Atención', 'Todos los campos del formulario son obligatorios.');
			return;
		}
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			showAlert('Atención', 'Introduce un correo electrónico válido.');
			return;
		}
		if (!acceptPolicy) {
			showAlert('Atención', 'Debes aceptar las políticas y condiciones de gestión de datos para continuar.');
			return;
		}
		onCompleteFirstLogin(firstLoginForm);
	};

	return (
		<main className="layout-login">
			<section className="hero-image"></section>

			<aside className="sidebar">
				<div className="sidebar__content">
					{firstLoginCod ? (
						<div className="login-form-container white">
							<h2 className="login-form__title">¡YA CASI ESTÁS DENTRO!</h2>
							<p className="login-form__subtitle">
								Completa tu perfil con tus datos para personalizar tu cuenta y
								define la contraseña con la que accederás a partir de ahora al
								portal.
							</p>
							<form onSubmit={handleFirstLoginSubmit} className="login-form" noValidate>
								<div className="form-group">
									<label htmlFor="name" className="form-group__label">
										Nombre
									</label>
									<input
										type="text"
										id="name"
										name="name"
										placeholder="Introduce tu nombre"
										value={firstLoginForm.name}
										onChange={handleFirstLoginChange}
										required
										className="form-group__input"
									/>
								</div>
								<div className="form-row">
									<div className="form-group">
										<label htmlFor="ape1" className="form-group__label">
											1º Apellido
										</label>
										<input
											type="text"
											id="ape1"
											name="ape1"
											placeholder="Introduce tu apellido"
											value={firstLoginForm.ape1}
											onChange={handleFirstLoginChange}
											required
											className="form-group__input"
										/>
									</div>
									<div className="form-group">
										<label htmlFor="ape2" className="form-group__label">
											2º Apellido
										</label>
										<input
											type="text"
											id="ape2"
											name="ape2"
											placeholder="Introduce tu apellido"
											value={firstLoginForm.ape2}
											onChange={handleFirstLoginChange}
											required
											className="form-group__input"
										/>
									</div>
								</div>

								<div className="form-group">
									<label htmlFor="email" className="form-group__label">
										Correo del trabajo
									</label>
									<input
										type="email"
										id="email"
										name="email"
										placeholder="Introduce tu email corporativo"
										value={firstLoginForm.email}
										onChange={handleFirstLoginChange}
										required
										className="form-group__input"
									/>
								</div>
								<div className="form-group">
									<label htmlFor="telefono" className="form-group__label">
										Teléfono de contacto
									</label>
									<input
										type="text"
										id="telefono"
										name="telefono"
										placeholder="Introduce tu teléfono de contacto"
										value={firstLoginForm.telefono}
										onChange={handleFirstLoginChange}
										required
										className="form-group__input"
									/>
								</div>
								<div className="form-group">
									<label htmlFor="dni" className="form-group__label">
										DNI
									</label>
									<input
										type="text"
										id="dni"
										name="dni"
										placeholder="Introduce tu DNI"
										value={firstLoginForm.dni}
										onChange={handleFirstLoginChange}
										required
										className="form-group__input"
									/>
								</div>
								<div className="form-group">
									<label htmlFor="dom_fiscal" className="form-group__label">
										Domicilio a efectos fiscales
									</label>
									<input
										type="text"
										id="dom_fiscal"
										name="dom_fiscal"
										placeholder="Introduce tu domicilio a efectos fiscales"
										value={firstLoginForm.dom_fiscal}
										onChange={handleFirstLoginChange}
										required
										className="form-group__input"
									/>
								</div>
								<div className="form-group">
									<label htmlFor="pwd" className="form-group__label">
										Nueva contraseña
									</label>
									<input
										type="password"
										id="pwd"
										name="pwd"
										placeholder="Elige una contraseña"
										value={firstLoginForm.pwd}
										onChange={handleFirstLoginChange}
										required
										className="form-group__input"
									/>
								</div>
								<div className="form-group form-group--check">
									<input
										type="checkbox"
										id="accept_policy"
										checked={acceptPolicy}
										onChange={(e) => setAcceptPolicy(e.target.checked)}
										required
									/>
									<label htmlFor="accept_policy">
										Acepto las políticas y condiciones de gestión de datos.*
									</label>
								</div>
								<button
									type="submit"
									className="login-form__submit"
								>
									RESTABLECER CONTRASEÑA
								</button>

								<div className="login-form__legal-text">
									<p>
										*Al participar en el concurso aceptas el tratamiento de tus
										datos por Mazda Automóviles España S.A. con el fin de
										gestionar el concurso y de practicar la retención fiscal que
										corresponda aplicar al total de los premios canjeados por
										cada vendedor. También podrán ser tratados por concesionario
										en el que trabajas con el fin de que éste proceda a la
										entrega de premios.
									</p>
									<p>
										Derechos: Los participantes podrán ejercer los derechos de
										acceso, rectificación, suspensión, oposición y cualquier
										otro derecho que corresponda en relación con los datos
										facilitados para el desarrollo del concurso por correo
										postal: Mazda Automóviles España. C/Manuel Pombo Angulo 28,
										2ª planta- 28050 Madrid, o por email:
										privacidad@mazdaeur.com. Para más información sobre la
										Protección de Datos de Mazda Automóviles España, consulta
										aquí:{' '}
										<a
											href="https://www.mazda.es/privacidad/"
											target="_blank"
											rel="noopener noreferrer"
										>
											https://www.mazda.es/privacidad/
										</a>
									</p>
								</div>
							</form>
						</div>
					) : !showForm ? (
						<>
							<div className="brand">
								<Lazy
									loadImage
									src={logoImage}
									alt="Mazda Logo"
									className="brand__logo"
								/>
							</div>

							<div className="copy">
								<h1>MAZDA ACCESSORY CHALLENGE</h1>
								<p>
									Bienvenida/o al portal exclusivo del Mazda Accessory
									Challenge, el espacio donde tus ventas de accesorios se
									transforman en puntos. Identifícate para gestionar tu catálogo
									de incentivos y descubrir todo lo que hemos preparado para ti.
								</p>
							</div>

							<button onClick={() => setShowForm(true)} className="cta">
								INICIAR SESIÓN
							</button>
						</>
					) : (
						// Formulario de login
						<div className="login-form-container pb-5">
							<button
								className="login-form__close"
								onClick={handleBackClick}
								aria-label="Cerrar formulario"
							>
								✕
							</button>

							<h2 className="login-form__title">
								BIENVENIDO A MAZDA ACCESSORY CHALLENGE
							</h2>

							<p className="login-form__subtitle">
								Si es tu primera vez aquí, accede con el código y la contraseña
								provisional que has recibido para configurar tu perfil. De lo
								contrario, utiliza tu contraseña personalizada que elegiste para
								continuar con el desafío
							</p>

							<form onSubmit={handleSubmit} className="login-form">
								<div className="form-group">
									<label htmlFor="cod_empleado" className="form-group__label">
										Código de vendedor/a
									</label>
									<input
										type="text"
										id="cod_empleado"
										name="cod_empleado"
										placeholder="Introduce tu código de vendedor/a"
										value={formData.cod_empleado}
										onChange={handleInputChange}
										required
										className="form-group__input"
									/>
								</div>

								<div className="form-group">
									<label htmlFor="pwd" className="form-group__label">
										Contraseña
									</label>
									<input
										type="password"
										id="pwd"
										name="pwd"
										placeholder="Introduce tu contraseña"
										value={formData.pwd}
										onChange={handleInputChange}
										required
										className="form-group__input"
									/>
								</div>

								<button type="submit" className="login-form__submit">
									INICIAR SESIÓN
								</button>

								<div className="login-form__legal-text dark">
									<p>
										Al participar en el concurso aceptas el tratamiento de tus
										datos por Mazda Automóviles España S.A. con el fin de
										gestionar el concurso y de practicar la retención fiscal que
										corresponda aplicar al total de los premios canjeados por
										cada vendedor. También podrán ser tratados por concesionario
										en el que trabajas con el fin de que éste proceda a la
										entrega de premios.
									</p>
									<p>
										Derechos: Los participantes podrán ejercer los derechos de
										acceso, rectificación, suspensión, oposición y cualquier
										otro derecho que corresponda en relación con los datos
										facilitados para el desarrollo del concurso por correo
										postal: Mazda Automóviles España. C/Manuel Pombo Angulo 28,
										2ª planta- 28050 Madrid, o por email:
										privacidad@mazdaeur.com. Para más información sobre la
										Protección de Datos de Mazda Automóviles España, consulta
										aquí:{' '}
										<a
											href="https://www.mazda.es/privacidad/"
											target="_blank"
											rel="noopener noreferrer"
										>
											https://www.mazda.es/privacidad/
										</a>
									</p>
								</div>
							</form>
						</div>
					)}
				</div>
			</aside>
		</main>
	);
};

export default LoginPage;
